import React, { useState } from "react";

import PropTypes from "prop-types";

import "./mobile-nabvar.css";

const MobileNabvar = (props) => {
  const [ativo, setAtivo] = useState(false);
  return (
    <div className={`mobile-nabvar-container ${props.rootClassName} `}>
      <a
        href="https://www.viacredi.coop.br/"
        target="_blank"
        rel="noreferrer noopener"
        className="mobile-nabvar-link"
      >
        <img
          alt="image"
          src="/lp/economiadacooperacao/logo-viacredi.svg"
          className="mobile-nabvar-image"
        />
      </a>
      <svg
        viewBox="0 0 1024 1024"
        onClick={() => setAtivo(!ativo)}
        className="mobile-nabvar-icon"
      >
        <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
      </svg>
      {ativo && (
        <div className="mobile-nabvar-container1">
          <a
            href="https://www.viacredi.coop.br/sua-cooperativa/sistema-ailos"
            target="_blank"
            rel="noreferrer noopener"
            className="mobile-nabvar-link1 OpenSans-T4"
          >
            Sistema Ailos
          </a>
          <a
            href="https://blog.ailos.coop.br/"
            target="_blank"
            rel="noreferrer noopener"
            className="mobile-nabvar-link2 OpenSans-T4"
          >
            Blog
          </a>
          <a
            href="https://contaonline.viacredi.coop.br/ib/auth"
            target="_blank"
            rel="noreferrer noopener"
            className="mobile-nabvar-link3"
          >
            <div className="mobile-nabvar-container2">
              <span className="mobile-nabvar-text OpenSans-T4">
                ACESSAR SUA CONTA
              </span>
            </div>
          </a>
          <a
            href="https://www.viacredi.coop.br/seja-um-cooperado"
            target="_blank"
            rel="noreferrer noopener"
            className="mobile-nabvar-link4"
          >
            <div className="mobile-nabvar-container3">
              <span className="mobile-nabvar-text1 OpenSans-T4">
                SEJA COOPERADO
              </span>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};

MobileNabvar.defaultProps = {
  rootClassName: "",
};

MobileNabvar.propTypes = {
  rootClassName: PropTypes.string,
};

export default MobileNabvar;
